import { METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const placeBetFlipCoinGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/coin-flip-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBetsService = (data) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/coin-flip-game/my-bets', data, {
    params: data,
    server: microServices.SERVICE_URL_1
  })
}
